// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

/* Override Ant Design header menu for dark header */
.ant-layout-header .ant-menu-horizontal {
  background: transparent !important;
  border-bottom: none !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item,
.ant-layout-header .ant-menu-horizontal .ant-menu-item a {
  color: rgba(255, 255, 255, 0.75) !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover,
.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover a {
  color: #fff !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected,
.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected a {
  color: #36cfc9 !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected::after {
  border-bottom-color: #36cfc9 !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item::after {
  border-bottom-color: transparent !important;
}

.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover::after {
  border-bottom-color: rgba(255, 255, 255, 0.5) !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wDAAwD;AAC1D","sourcesContent":[".App {\n  text-align: center;\n}\n\n/* Override Ant Design header menu for dark header */\n.ant-layout-header .ant-menu-horizontal {\n  background: transparent !important;\n  border-bottom: none !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item,\n.ant-layout-header .ant-menu-horizontal .ant-menu-item a {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover,\n.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover a {\n  color: #fff !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected,\n.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected a {\n  color: #36cfc9 !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item-selected::after {\n  border-bottom-color: #36cfc9 !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item::after {\n  border-bottom-color: transparent !important;\n}\n\n.ant-layout-header .ant-menu-horizontal .ant-menu-item:hover::after {\n  border-bottom-color: rgba(255, 255, 255, 0.5) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
